export default __webpack_public_path__ + "src/assets/downloads/User Guide - Register of Tailings Storage Facilities and Dams.pdf";